"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingStarIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var RatingStar = function RatingStar(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "m12 0 3.708 7.9L24 9.167l-6 6.15L19.416 24 12 19.9 4.584 24 6 15.317l-6-6.15L8.292 7.9 12 0Zm3.03 8.808L12 2.353 8.97 8.808 2.074 9.861l4.994 5.119-1.167 7.148L12 18.758l6.098 3.37-1.166-7.148 4.993-5.119-6.895-1.053Z",
    fillRule: "nonzero"
  }));
};
RatingStar.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const RatingStarIcon = exports.RatingStarIcon = (0, _createIconComponent.default)(RatingStar, 'RatingStar');